import { render, staticRenderFns } from "./OrgSelect.vue?vue&type=template&id=48c4d5d2"
import script from "./OrgSelect.vue?vue&type=script&lang=js"
export * from "./OrgSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports